import { render, staticRenderFns } from "./ChartFunnel.vue?vue&type=template&id=2f531604&scoped=true"
import script from "./ChartFunnel.vue?vue&type=script&lang=js"
export * from "./ChartFunnel.vue?vue&type=script&lang=js"
import style0 from "./ChartFunnel.vue?vue&type=style&index=0&id=2f531604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f531604",
  null
  
)

export default component.exports